import React from 'react';
import { SiteLink } from 'components';

export function AppSideBar() {
  return (
    <div className="appSideBar">
      <div className="appSideBar__scroll">
        <section className="appSideBar__section">
          <h5>Data</h5>
          <ul className="appSideBar__group">
            <li>
              <SiteLink to="/admin/products">Products</SiteLink>
            </li>
          </ul>
        </section>

        <section className="appSideBar__section">
          <h5>WHERE TO BUY</h5>
          <ul className="appSideBar__group">
            <li>
              <SiteLink to="/admin/stores/AU">Australia</SiteLink>
            </li>
            <li>
              <SiteLink to="/admin/stores/NZ">New Zealand</SiteLink>
            </li>
          </ul>
        </section>

        <section className="appSideBar__section">
          <h5>WARRANTY</h5>
          <ul className="appSideBar__group">
            <li>
              <SiteLink to="/admin/warranty">Warranty Registrations</SiteLink>
            </li>
          </ul>
        </section>

        <section className="appSideBar__section">
          <h5>CONTACT</h5>
          <ul className="appSideBar__group">
            <li>
              <SiteLink to="/admin/contacts">Contact Submission</SiteLink>
            </li>
          </ul>
        </section>

        <section className="appSideBar__section">
          <h5> JOIN </h5>
          <ul className="appSideBar__group">
            <li>
              <SiteLink to="/admin/join"> Join Submission</SiteLink>
            </li>
          </ul>
        </section>

      </div>
    </div>
  );
}
